import React from 'react';
import { authCardStyle, villageCardCenterStyle } from '../constants/authStyles';
import './AuthLayeredCard.css';

// Not: çağıranın style'ı kart arka planını ezmesin diye birleştirilir (ör. Pazar CSS değişkenleri).
const AuthLayeredCard = React.forwardRef(({ children, className = '', style, ...props }, ref) => (
  <div
    ref={ref}
    className={`auth-card auth-layered-card${className ? ` ${className}` : ''}`}
    style={style ? { ...authCardStyle, ...style } : authCardStyle}
    {...props}
  >
    <div
      className="auth-layered-card__center-fill"
      style={villageCardCenterStyle}
      aria-hidden="true"
    />
    {children}
  </div>
));

AuthLayeredCard.displayName = 'AuthLayeredCard';

export default AuthLayeredCard;
